import { ListViewFilterTag } from '@coin/shared/core/util-models';
import { ListViewFilterTagType } from '@coin/shared/core/util-enums';

enum FilterKey {
  Organisations = 'Organisations'
}

export const ORGANISATION_FILTERS: ListViewFilterTag[] = [
  {
    title: 'cosmos.organisations',
    titleTranslateText: 'cosmos.organisations',
    icon: 'account_tree',
    color: 'petrol',
    filterKey: FilterKey.Organisations,
    type: ListViewFilterTagType.DropdownWithoutTotalCount,
    isMultiSelect: false,
    subFilters: []
  }
];
